
  var url = 'https://app.tellephant.com/assets/js/whatsapp-web.js?52474';
  var s = document.createElement('script');
  s.type = 'text/javascript';
  s.async = true;
  s.src = url;
  var options = {
  "enabled":true,
  "chatButtonSetting":{
  "backgroundColor":"#4dc247",
  "ctaText":"",
  "borderRadius":"25",
  "marginLeft":"0",
  "marginBottom":"50",
  "marginRight":"50",
  "position":"right"
  },
  "brandSetting":{
  "brandName":"CHOKORE",
  "brandSubTitle":"Typically replies as soon as possible",
  "brandImg":"https://app.tellephant.com/assets/images/support.jpg",
  "welcomeText":"Hi, there! How can I help you?",
  "messageText":"Hello, I have a question about {{page_link}}",
  "backgroundColor":"#0a5f54",
  "ctaText":"Start Chat",
  "borderRadius":"25",
  "autoShow":false,
  "phoneNumber":"919650429889"
  }
  };
  s.onload = function() {
  CreateWhatsappChatWidget(options);
  };
  var x = document.getElementsByTagName('script')[0];
  x.parentNode.insertBefore(s, x);
 
  // click copy js
  document.addEventListener('DOMContentLoaded', function () {
    // Create the toast element and add to body
    let toast = document.createElement('div');
    toast.id = 'copy-toast';
    toast.className = 'copy-toast';
    document.body.appendChild(toast);

    // Add click event to all promo codes
    document.querySelectorAll('.copy-code').forEach(function (el) {
      el.addEventListener('click', function () {
        const promoCode = this.getAttribute('data-code');

        // Copy to clipboard
        const tempInput = document.createElement('input');
        document.body.appendChild(tempInput);
        tempInput.value = promoCode;
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);

        // Show toast
        toast.textContent = `Code "${promoCode}" copied!`;
        toast.classList.add('show');

        // Hide toast after 2.5 seconds
        setTimeout(() => {
          toast.classList.remove('show');
        }, 2500);
      });
    });
  }); 